
export enum TYPE_KEYBOARD {
  PIN_PASSWORD = 'PIN-PASSWORD',
  PHONE = 'PHONE',
  CURRENCY = 'CURRENCY',
  NUMBER = 'NUMBER'
}
export type IKeyboardType = 'PIN-PASSWORD' | 'PHONE' | 'CURRENCY' | 'NUMBER';

